import { generatePath } from "react-router-dom";

export const USER_ROUTE_PATTERNS = {
  PROFILE: "/users/:userId",
} as const;

export const userProfilePath = (userId: number) =>
  generatePath(USER_ROUTE_PATTERNS.PROFILE, { userId: String(userId) });
